import React from 'react';
import Label from "../../components/label/Label";

const _text = "This report is too large to be displayed below but can be exported, Click “Export CSV” at the upper right to continue.";
export default function ReportTooLargeWarning({display = false, text = _text}) {
    if (!display) return null;
    return (
        <Label orange>{text}</Label>
    );
}


// WEBPACK FOOTER //
// ./src/pages/customReport/ReportTooLargeWarning.jsx